export default {
  props: {
    value:{
      type: [String,Number,Object,Array],
      default: () => null
    },
    list:{
      type: Array,
      default: () => ([])
    },
  },
  computed: {
    buttonList:(_this = this) => _this.$props.list?.map(ele => ({
      value: ele?.value,
      label: ele?.label,
      disabled: ele?.disabled,
      active: _this.isActive(ele?.value)
    })),
  },
  methods: {
    isActive(value){
      return String(value) === String(this.$props.value)
    },
    clickButton(button){
      const { value,active,disabled } = button
      if(active || disabled) return
      this.$emit('input',value)
      this.$nextTick(() => this.$emit('change',value))
    }
  }
}
